import React from 'react'
import {
    Modal,
    message,
    Col,
    ConfigProvider,
    DatePicker,
    Pagination,
    Space,
    Table,
    Spin,
    Row,
    Button
} from 'antd'
import {ReloadOutlined} from '@ant-design/icons'
import './index.less'
import zhCN from "antd/es/locale/zh_CN";
import {getShopFinanceList, getShopPunishList} from '../../constants/api'
import {removeToken} from "../../utils/cookie";
import moment from "moment";
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

export default class Collection extends React.Component {

    state = {
        dataLoading:false,
        financeRecordList: [],
        financeRecordListCurrent: 1,
        financeRecordListPagesize: 10,
        financeRecordListTotal: 0,

        bigImgVisible: false, //大图弹窗
        bigImgUrl: '',//大图URL

        settlementMonth: moment(new Date()).subtract(1,'months').format('YYYY-MM'),//结算月
        punishList: []
    }

    componentDidMount() {
        this.searchFinanceR(1, 10)
        this.searchPunish(this.state.settlementMonth)
    }

    searchFinanceR = (current, size) => {
        this.setState({dataLoading: true})
        getShopFinanceList({
            pageIndex: current,
            pageSize: size,
            sortName: "",
            sortType: "",
        }).then((res) => {
            this.setState({dataLoading: false})
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    if (data.data != null) {
                        this.setState({
                            financeRecordList: data.data.records,
                            financeRecordListTotal: data.data.total,
                        })
                    } else {
                        message.success('无数据')
                        this.setState({
                            financeRecordList: [],
                            financeRecordListTotal: 0,
                        })
                    }
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            this.setState({dataLoading: false})
            message.error(error.toString())
        })
    }
    onChangePageManageR = (page, pageSize) => {
        this.setState({financeRecordListCurrent: page}, () => {
            this.searchFinanceR(page, this.state.financeRecordListPagesize)
        })
    }
    onChangeSizeManageR = (current, size) => {
        this.setState({financeRecordListPagesize: size})
    }

    searchPunish = (settlementMonth) => {
        getShopPunishList({
            moneyMonth: settlementMonth
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    if (data.data != null) {
                        this.setState({
                            punishList: data.data,
                        })
                    } else {
                        this.setState({
                            punishList: [],
                        })
                    }
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }

    showBigImg = (imageUrl) => {
        this.setState({bigImgVisible: true, bigImgUrl: imageUrl})
    }
    onHandleImgOk = (e) => {
        this.setState({
            bigImgVisible: false,
        });
    }
    onHandleImgCancel = (e) => {
        this.setState({
            bigImgVisible: false,
        });
    }

    onChangeSettlement(date, dateString) {
        this.setState({
            settlementMonth: dateString
        })
    }
    searchCurrentPunish = () => {
        this.searchPunish(this.state.settlementMonth)
    }

    render() {
        const columnsFinanceR = [
            {
                title: '结算月',
                dataIndex: 'moneyMonth',
            },
            {
                title: '店铺名称',
                dataIndex: 'shopName',
            },
            {
                title: '保证金(已交/应交)',
                dataIndex: '',
                render: (text, record) => (
                    <Space size="middle">
                        {
                            (parseFloat(record.bondMoneyPay) - parseFloat(record.bondMoney)) < 0 ?
                                <span style={{color: '#FF0000'}}>{record.bondMoneyPay}/{record.bondMoney}</span> :
                                <span style={{color: '#05a500'}}>{record.bondMoneyPay}/{record.bondMoney}</span>
                        }
                    </Space>
                ),
            },
            {
                title: '本月营业额',
                dataIndex: 'shouldMoney',
            },
            {
                title: '本月扣点(费率)',
                dataIndex: 'rate',
            },
            {
                title: '处罚扣款',
                dataIndex: 'punishMoney',
            },
            {
                title: '应打款金额',
                dataIndex: 'actualMoney',
            },
            {
                title: '收款信息',
                dataIndex: '',
                render: (text, record) => (
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <span>{record.accountName}，{record.accountNo}</span>
                        {
                            record.accountType == 1 ?
                                <span style={{backgroundColor: '#0088ff', padding: 2, color: '#ffffff', alignSelf: 'flex-start'}}>支付宝</span> :
                                record.accountType == 2 ?
                                    <span style={{backgroundColor: '#ff4800', padding: 2, color: '#ffffff', alignSelf: 'flex-start'}}>银行卡</span>
                                    : ''
                        }
                        {
                            record.accountType == 1 ?
                                <span style={{color: '#121212'}}></span> :
                                record.accountType == 2 ?
                                    <span style={{color: '#ff4800'}}>{record.accountBankName}</span>
                                    : ''
                        }
                        {
                            record.accountType == 1 ?
                                <span style={{color: '#121212'}}></span> :
                                record.accountType == 2 ?
                                    <span style={{color: '#ff4800'}}>{record.accountBankAdress}</span>
                                    : ''
                        }
                    </div>
                ),
            },
            {
                title: '打款人名称',
                dataIndex: 'moneyOperatorName'
            },
            {
                title: '打款信息',
                dataIndex: '',
                width: 280,
                ellipsis: false,
                render: (text, record) => (
                    <div>
                        {
                            <div
                                style={{height: 70, display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                                {
                                    (!record.remarkImage || record.remarkImage == '' || record.remarkImage == null) ?
                                        null
                                        :
                                        <img style={{width: 70, height: 70, cursor: "pointer"}} src={record.remarkImage} onClick={this.showBigImg.bind(this, record.remarkImage)}/>
                                }
                                <div style={{
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    marginLeft: "8px",
                                }}>{
                                    record.remark
                                }
                                </div>
                            </div>
                        }
                    </div>
                ),
            },
            {
                title: '状态',
                dataIndex: '',
                render: (text, record) => (
                    <Space size="middle">
                        {
                            record.dataStatus == 2 ?
                                <span style={{color: '#05a500'}}>已打款</span>
                                : <span style={{color: '#ff0000'}}>未打款</span>
                        }
                    </Space>
                ),
            }
        ];
        const columnsPunish = [
            {
                title: '店铺名称',
                dataIndex: 'shopName',
            },
            {
                title: '处罚金额',
                dataIndex: 'price',
                render: (text, record) => (
                    <Space size="middle">
                        <span style={{color: '#FF0000', fontSize: 16}}>￥{record.price}</span>
                    </Space>
                ),
            },
            {
                title: '处罚原因',
                dataIndex: 'reason',
            },
            {
                title: '证据',
                dataIndex: 'images',
                render: (text, record) => (
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        {
                            (record.images != null && record.images.length > 0) ?
                                record.images.map((item) => {
                                    return <div key={item} style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                        <img style={{width: 70, height: 70, cursor: "pointer"}} src={item}
                                             onClick={this.showBigImg.bind(this, item)}/>
                                    </div>
                                })
                                : null
                        }
                    </div>
                ),
            },
        ]

        return (
            <div>
                <Row style={{marginRight: 190, marginBottom: -15, padding: '20px 20px 20px 30px'}} gutter={[8, 8]}>
                    <Col className="gutter-row" span={5}>
                        <span style={{fontSize: 18, color: '#121212', fontWeight: 'bold'}}>财务打款信息</span>
                    </Col>
                </Row>
                <Col>
                    <div style={{padding: '0 10px 0 10px'}}>
                        <Spin size="large" spinning={this.state.dataLoading}>
                        <Table rowKey="shopId"
                               bordered = {true}
                               columns={columnsFinanceR}
                               pagination={false}
                               dataSource={this.state.financeRecordList}/>
                        </Spin>
                        <ConfigProvider locale={zhCN}>
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                                marginTop: 10,
                                marginRight: 20,
                                marginBottom: 20
                            }}>
                                <Pagination style={{marginTop: 5}}
                                            onShowSizeChange={this.onChangeSizeManageR}
                                            current={this.state.financeRecordListCurrent}
                                            pageSize={this.state.financeRecordListPagesize}
                                            total={this.state.financeRecordListTotal}
                                            onChange={this.onChangePageManageR}/>
                            </div>
                        </ConfigProvider>
                    </div>
                </Col>

                <Row style={{marginBottom: -15, padding: '20px 20px 20px 30px'}} gutter={[8, 8]}>
                    <Col className="gutter-row" span={5}>
                        <span style={{fontSize: 18, color: '#121212', fontWeight: 'bold'}}>处罚扣款信息</span>
                    </Col>
                </Row>
                <ConfigProvider locale={zhCN}>
                    <Row style={{marginBottom: -15, padding: '0px 20px 20px 30px'}} gutter={[8, 8]}>
                        <Col className="gutter-row" span={3}>
                            <DatePicker
                                picker="month"
                                value={(this.state.settlementMonth === '') ? null : moment(this.state.settlementMonth, 'YYYY-MM')}
                                placeholder={'结算月'}
                                onChange={this.onChangeSettlement.bind(this)}/>
                        </Col>
                        <Col className="gutter-row" span={5}>
                            <Button type="primary" onClick={this.searchCurrentPunish.bind(this)}>
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </ConfigProvider>
                <Col>
                    <div style={{padding: '0 10px 0 10px'}}>
                        <Table rowKey="id"
                               bordered = {true}
                               columns={columnsPunish}
                               pagination={true}
                               dataSource={this.state.punishList}/>
                    </div>
                </Col>

                <Modal
                    width={'480px'}
                    visible={this.state.bigImgVisible}
                    onOk={this.onHandleImgOk.bind(this)}
                    onCancel={this.onHandleImgCancel.bind(this)}
                    okText="确认"
                    cancelText="取消"
                    footer={null}
                >
                    <div style={{width: '100%', height: '400px'}}>
                        <img style={{width: '400px', height: '400px'}} src={this.state.bigImgUrl} />
                    </div>
                </Modal>
            </div>
        );

    }
}




// WEBPACK FOOTER //
// ./src/pages/collection/index.js